import PropTypes from 'prop-types'
import React from 'react'
import RepeatOneTwoToneIcon from '@material-ui/icons/RepeatOneTwoTone'
import RepeatGroupField from '../question_config_fields/RepeatGroupField'
import BoldLabelAndContent from '../../molecules/BoldLabelAndContent'
import RepeatGroupCitizenField from '../question_fields/RepeatGroupCitizenField'

const Form = props => {
  return <RepeatGroupField baseName={props.baseName} />
}

const Template = props => {
  return <RepeatGroupCitizenField payload={props.question.payload} name={props.name} disabled />
}

const Answer = props => {
  return (
    <BoldLabelAndContent label={`${props.question.payload?.label}: `} content={props.answer} el="li">
      {props.children}
    </BoldLabelAndContent>
  )
}

const RepeatGroupQuestion = {
  selectOption: {
    value: 'repeat_group',
    label: 'Grupo de preguntas repetibles',
    icon: <RepeatOneTwoToneIcon fontSize="small" />
  },
  Answer,
  Form,
  Template,
  name: 'RepeatGroupQuestion'
}

export default RepeatGroupQuestion

Form.propTypes = {
  baseName: PropTypes.string
}

Template.propTypes = {
  name: PropTypes.string,
  question: PropTypes.object.isRequired
}

Answer.propTypes = {
  answer: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  children: PropTypes.node,
  question: PropTypes.object
}
